// extracted by mini-css-extract-plugin
export default {"root":"loading-dots-module--root--54c70"};